import BaseModule from '@/store/baseModule';
import BaseModulePlugins from '@/store/baseModule/plugins';
import BaseService from '@/services/services/tools/baseService';
import BaseAPI from '@/services/api/internal/tools/baseAPI';

export default (store) => {
  store.registerModule(
    ['logbook', 'origins'],
    new BaseModule({
      serviceAPI: new BaseService({
        api: new BaseAPI({
          url: `${process.env.MYPREDITY_BASE_URI}/logbooks/payloads/origins`,
        }),
        retry: { nbLeft: 3, timeout: 2000 },
      }),
    })
  );

  const basePlugin = new BaseModulePlugins({
    module: 'logbook/origins',
    store,
  });

  basePlugin.onInit(() => store.dispatch('logbook/origins/initItems'));
};
